import {
  Loading
} from 'element-ui'

const Loading2 = function* loadingYield(that) {
  // loading.next() 首次调用开启 
  yield that.loadingInstance = Loading.service({
    fullscreen: true,
    target: 'document.body',
    lock: true,
    text: '加载中',
    background: 'rgba(255, 255, 255, .8)'
  })
  // 再次调用关闭
  yield that.$nextTick(() => {
    that.loadingInstance.close()
  })
}


export {
  Loading2
}



// WEBPACK FOOTER //
// ./src/common/loading2.js